var dd = require('react-dd');
var _ = require('lodash');
var esUtils = require('../../../utils/esUtils');
var HoverMixin = require('../../../utils/HoverMixin');
var FormInputMixin = require('../FormInputMixin');

var component = dd.createClass({
	mixins: [FormInputMixin, HoverMixin],
	__onChange: function(e){
		this._input_newValue(e.target.value);
	},
	getInitialState: function(){
		return {dd_open: false};
	},
	__toggleDropDown: esUtils.wrapPreventDefault(function(){
		this.setState({dd_open: !this.state.dd_open});
	}),
	hoverable_onUserLeftHoverable: function(){
		if(this.state.dd_open){//only setState if needed
			this.setState({dd_open: false});
		}
	},
	__itemSelected: function(value){
		var self = this;
		return esUtils.wrapPreventDefault(function(){
			if(_.isFunction(self.props.__onSelectTransform)){
				value = self.props.__onSelectTransform(value);
			}
			self.setState({dd_open: false});
			self._input_newValue(value);
		});
	},
	render: function(){
		var self = this;
		var field = this.props.field;
		var value = this.props.value;

		if(field.read_only){
			return dd.p({className: 'form-control-static'},
				_.has(field.options, value) ? field.options[value] : value
			);
		}

		var type_in = dd.input({
			type: 'text',
			placeholder: field.placeholder || null,
			className: 'form-control',
			value: value || '',
			name: this.props.field_path,
			onChange: this.__onChange
		});
		if(_.isEmpty(field.options)){
			return type_in;
		}
		return dd.div({className: 'input-group'},
			type_in,
			dd.span({
					className: 'input-group-btn' + (this.state.dd_open ? ' open' : ''),
					onMouseEnter: this.hoverable_onMouseEnter,
					onMouseLeave: this.hoverable_onMouseLeave
				},
				dd.button({className: 'btn btn-default', onClick: this.__toggleDropDown},
					dd.span({className: 'caret'})
				),
				dd.ul({className: 'dropdown-menu pull-right', style: {overflowY: 'auto', maxHeight: 150}},
					_.map(field.options, function(name, val){
						return dd.li({key: val}, dd.a({href: '#', onClick: self.__itemSelected(val)}, name));
					})
				)
			)
		);
	}
});

module.exports = {
	component: component
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/inputs/Combo.js
// module id = 187
// module chunks = 0 1 2 3 4